import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Roleplay from "@/pages/Roleplay";
import Coach from "@/pages/Coach";
import Courses from "@/pages/Courses";
import Challenges from "@/pages/Challenges";
import Leaderboard from "@/pages/Leaderboard";
import Admin from "@/pages/Admin";
import Pricing from "@/pages/Pricing";
import Battles from "@/pages/Battles";
import Teams from "@/pages/Teams";
import Tournaments from "@/pages/Tournaments";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Plan from "@/pages/Plan";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Account from "@/pages/Account";
import Share from "@/pages/Share";
import CoachShare from "@/pages/CoachShare";
import Lesson from "@/pages/Lesson";
import Workshops from "@/pages/Workshops";
import CertificatePage from "@/pages/CertificatePage";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center bg-slate-50 text-emerald-600 font-mono text-sm">Loading Pitch Craft…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (adminOnly && user.role !== "admin" && !user.is_manager) return <Navigate to="/app" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/share/:id" element={<Share />} />
            <Route path="/coach-share/:id" element={<CoachShare />} />
            <Route path="/cert/:id" element={<CertificatePage />} />
            <Route path="/app/account" element={<Protected><Account /></Protected>} />
            <Route path="/delete-account" element={<Navigate to="/app/account" replace />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/roleplay" element={<Protected><Roleplay /></Protected>} />
            <Route path="/app/coach" element={<Protected><Coach /></Protected>} />
            <Route path="/app/plan" element={<Protected><Plan /></Protected>} />
            <Route path="/app/courses" element={<Protected><Courses /></Protected>} />
            <Route path="/app/courses/:lessonId" element={<Protected><Lesson /></Protected>} />
            <Route path="/app/workshops" element={<Protected><Workshops /></Protected>} />
            <Route path="/app/challenges" element={<Protected><Challenges /></Protected>} />
            <Route path="/app/leaderboard" element={<Protected><Leaderboard /></Protected>} />
            <Route path="/app/battles" element={<Protected><Battles /></Protected>} />
            <Route path="/app/teams" element={<Protected><Teams /></Protected>} />
            <Route path="/app/tournaments" element={<Protected><Tournaments /></Protected>} />
            <Route path="/app/pricing" element={<Protected><Pricing /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/app/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="light" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
